export type FiatCurrency = {
  name: string
  code: string
  minAmount: number
  icon: string
}
